import { Action } from '@ngrx/store';
import { from, mergeMap, Observable, of, OperatorFunction } from 'rxjs';

import { Survey } from '@ps/survey-utils';

import { SurveyCreationCoreApiActions } from '../survey-creation-core.actions';

interface LoadActiveChildOptions {
  readonly precedingActions?: readonly Action[];
  readonly notify?: boolean;
  readonly recalculationsEnabled?: boolean;
}

export function loadActiveChild$(
  survey$: Observable<Survey>,
  psCatchError: <T, R>(
    handler: (error: { message: string }) => Observable<R>,
    options?: { notify?: boolean },
  ) => OperatorFunction<T, T | R>,
  {
    precedingActions = [],
    notify = false,
    recalculationsEnabled = true,
  }: LoadActiveChildOptions = {},
): Observable<Action> {
  return survey$.pipe(
    mergeMap((survey: Survey) =>
      from([
        ...precedingActions,
        SurveyCreationCoreApiActions.loadActiveSurveyForEditSuccess({
          survey,
          recalculationsEnabled,
        }),
      ]),
    ),
    psCatchError(
      (error) =>
        of(
          SurveyCreationCoreApiActions.loadActiveSurveyForEditFailure({
            error: error.message,
          }),
        ),
      { notify },
    ),
  );
}
